import * as types from 'constants/action_types'

export default function doUpdateLabels(labels, removedLabels) {
  return {
    type: types.UPDATE_LABELS,
    data: {
      labels,
      removedLabels,
    },
  }
}
